module.exports = __webpack_public_path__ + "img/gall-4.c618e3c4.jpg";